import { useEffect } from "react";
import { CONSENT_EVENT, exposeConsentApi, initMetaPixel } from "../utils/metaPixel";

// Lance le pixel si le consentement existe déjà, ou dès qu'il est accordé.
export function useMetaPixel(): void {
  useEffect(() => {
    exposeConsentApi();
    initMetaPixel();
    const onConsent = () => initMetaPixel();
    window.addEventListener(CONSENT_EVENT, onConsent);
    return () => window.removeEventListener(CONSENT_EVENT, onConsent);
  }, []);
}
